import React, { PureComponent  } from 'react';
// import Wrp from '../../hoc/Wrp/Wrp';
import http from '../../services/http';
import {isSet} from '../../Utils/CommonFunctions';
import {placeActionButtons} from '../../Containers/LayoutContainer/LayoutCommonFunction';
import htmlToJson from 'html-to-json';
import $ from 'jquery';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
  buildElementString,
  extractStylesAsObjects,
  getOutputFieldsElement,
  injectVariableValues,
  isClassDefined,
  prefixClassesForJS,
  scopeCssWithClass,
  splitFunctionAndArgs,
  uniqueStr
} from './MarkupFunctions';
import HyperTextElementBuilder from './HyperTextElementBuilder';
import { loadPagesConfigAction,setActiveConfigPagesAction,goToHistoryPageAction } from '../../store/actions/PagesAction';


const BLOCKED_TAGS_REPLACEMENT = {'html':'manualhtml','meta':'manualheta','title':'manualtitle','script1':'manualscript','form':'manualform'};
const BLOCKED_TAGS = ['html','meta','title','script1','form'];
let JAVASCRIPT_SCRIPT = [];


class MarkupConversion extends PureComponent  {
    constructor(props) {
        super(props);
        this.state = {
          htmlElement:[],
          childActionButtons:{},
          inlineStyles:'',
          dynamicAssignVar:{}
        };
        this.hasMounted = {};
        this.functionMap = {
          rotateCard: this.rotateCard.bind(this),
          dynamicVariableMethod: this.dynamicVariableMethod.bind(this)
        }
        this.prefix = uniqueStr();
    }
    
    // Method to handle rotating the card
    rotateCard(btn) {
      // Find the closest ancestor with class 'rates-container'
      var $card = btn.currentTarget.closest('.rates-container');
      // Check if $card has class 'hover'
      if ($card.classList.contains('hover')) {
          // Remove 'hover' class if present
          $card.classList.remove('hover');
      } else {
          // Add 'hover' class if not present
          $card.classList.add('hover');
      }
    }

    // Method to dynamically assign variables
    dynamicVariableMethod(key, val) {
      this.setState(prevState => ({
          dynamicAssignVar: {
              ...prevState.dynamicAssignVar,
              [key]: val
          }
      }));
    }
    componentDidUpdate = (prevProps)=>{
        // Re-parse only when template changes — not on every fieldGroups update (remounts MultiLookup/CustomAll).
        if(prevProps.htmlContent!==this.props.htmlContent){
          this.convertMarkupToJSON(this);
        }
    }
  
  componentDidMount = ()=>{
      const {actionButton} = this.props;
      // console.log(actionButton);
      if(actionButton && isSet(actionButton.window_mapping_id,null)!==null){
        //API CALL FOR MANNUAL WINDONW ACTION BUTTON DETAILS
        this.fetchActionButtonLists(isSet(actionButton.window_mapping_id,null));
      }
        this.convertMarkupToJSON(this);
        window.addEventListener("resize", this.updateDimensions);
        this.updateDimensions();
  }

  fetchActionButtonLists = (windowId)=>{
   
    const queryString = '?query=&page=0&orderBy=&size=1000&direction=';
    const API_Url = "component-actions/list/"+windowId+queryString;
    http.GET(API_Url)
        .then(res => {
          if(res.status===200){ 
            const response = res.data;
            const {match} = this.props;
            const params = match.params;
            if(response.code===200){
              const responseData = response.data.content;
              const actionBtn = placeActionButtons({
                components:responseData,
                params:params
              });
              this.setState({
                childActionButtons:actionBtn
              });
            }
          }
    }).catch(err => {
          console.log(err);
    })
  }
  componentWillUnmount() {
    this.updateDimensions();
  }
  //Toogle listener left-bar while resize
  updateDimensions = ()=>{
    $('#sidebarCollapse').on('click', function () {
      $('#splitView_sidebar').toggleClass('active');
      $('.sidebarOverlay').toggleClass('overlayVisible');
    });
    if ($(window).width() < 992) {
        $('#splitView_sidebar').addClass('active');
    } else {
        $('#splitView_sidebar').removeClass('active');
    }
  }

    render() {
        const {htmlElement} = this.state;
        return this.convertAndCreateElement(htmlElement,{loopData:[],dynamicVar:{}});
    }

     convertAndCreateElement = (htmlElement,paramObj)=>{
      const {childActionButtons,dynamicAssignVar} = this.state;
      const {loopData,dynamicVar,dataTable} = paramObj;
      let displayContent = '';
        return htmlElement.map((item,itemIndex)=>{
            const {children,type} = item;
            const attribs = (item.hasOwnProperty('attribs')===true)?item.attribs:{};
            let tagName   = (item.hasOwnProperty('name')===true)?item.name:'';
            if(BLOCKED_TAGS.indexOf(tagName)!==-1){
              tagName = BLOCKED_TAGS_REPLACEMENT[tagName];
            }
            const updatedAttrbs = this.convertToReactEvent(attribs);
            // let attributes ={
            //   ...updatedAttrbs,
            //   className:[updatedAttrbs.class].join(' '),
            //   id:isSet(attribs.id,itemIndex),
            // }
            // let { class: cls, ...restAttrbs } = updatedAttrbs;
            // console.log('updatedAttrbs',updatedAttrbs,restAttrbs,(isSet(cls,null)!==null && { className: [isSet(cls,'')].join(' ') }));
            let attributes = {
              ...updatedAttrbs,
              // className:isSet(updatedAttrbs.class,''),
              // ...updatedAttrbs,
              // ...(cls && { className: [isSet(cls,'')].join(' ') }),
              id: isSet(attribs.id, itemIndex),
            };

            const elmtParams = {
              tagName:tagName,
              loopData:loopData,
              defProps:this.props,
              dataTable:dataTable,
              dynamicVar:dynamicVar,
              children:children,
              dynamicAssignVar:dynamicAssignVar,
              childActionButtons:childActionButtons,
              convertAndRenderElement:this.convertAndCreateElement
            };
           
            if(attributes.hasOwnProperty('style') && typeof attributes.style==='string'){
              attributes.style = extractStylesAsObjects(attributes.style);
            }
            
            if ($(window).width() < 768) {
                $('#splitView_sidebar').addClass('active');
            } else {
                $('#splitView_sidebar').removeClass('active');
            }
       
        for (let key in attributes) {
          if((key==='class' || key==='classname' || key==='title' || key==='id' || key==='href')){
            const attrbsElmt = attributes[key].toString();
            let  attrDisplayContent = attrbsElmt;
            
            if((key==='class' || key==='classname') && Object.hasOwn(attributes, 'data-onload-class')===true){
              // console.log('isObject',attrDisplayContent,Object.hasOwn(attributes, 'data-onload-class'));
              let element = document.getElementById(attributes.id);
              if(element){
                attributes = {
                  ...attributes,
                  [key]:isSet(element.getAttribute('class'),'')
                }
                // continue;
              }
            }
           
            if(isSet(attrDisplayContent,null)!==null && attrDisplayContent.indexOf('${') !== -1 && attrDisplayContent.indexOf('}') !== -1){
              const paramsPattern = /[^${\}]+(?=})/g;
              let extractParams = attrbsElmt.match(paramsPattern);
              isSet(extractParams,[]).forEach((expFiedName)=>{
                const layoutPersistedOnly = (key==='class' || key==='classname')
                  && Object.hasOwn(attributes, 'data-onload-class')===true;
                let replacingValue = getOutputFieldsElement({
                  ...attributes,
                  value:expFiedName.trim(),
                  persistedOnly:layoutPersistedOnly
                },elmtParams);
                replacingValue     = (replacingValue==='-')?'':replacingValue;
                
                if(key==='class' || key==='classname'){
                  attrDisplayContent = attrDisplayContent.replace('${'+expFiedName+'}',`"${replacingValue}"`);
                }else{
                  attrDisplayContent = attrDisplayContent.replace('${'+expFiedName+'}',`${replacingValue}`);
                }
                

                const ternaryRegex = /\(.*?\)\s*\?\s*.*?\s*:\s*.*/;
                
                 if(ternaryRegex.test(attrDisplayContent)===true){
                  try{
                    attrDisplayContent = eval(attrDisplayContent);
                  }catch(e){
  
                  }
                 }
                //  console.log('attrDisplayContent',attrDisplayContent);
                attributes = {
                  ...attributes,
                  [key]:attrDisplayContent
                }
              });
                  
               }
           
            }
        }
      
      //LOAD JS SCRIPT  
      try{
        if(item?.parent?.type==='script'){
          let jsContent = item.data;
          // console.log('JAVASCRIPT_SCRIPT',JAVASCRIPT_SCRIPT,jsContent);
          // const functionNames = [];
          // const regex = /function\s+([a-zA-Z0-9_]+)/g;

          // let match;
          // while ((match = regex.exec(jsContent)) !== null) {
          //   functionNames.push(match[1]);
          // }
          // console.log('JAVASCRIPT_SCRIPT111',functionNames);
          // if(isSet(JAVASCRIPT_SCRIPT,null)!==null){
          //   jsContent = JAVASCRIPT_SCRIPT+'\n'+jsContent;
          //   JAVASCRIPT_SCRIPT = '';
          // }
          displayContent = isSet(this.getJsScriptContent(jsContent),'');
          // console.log('displayContent',displayContent);
        }
      }catch(e){

      }

      try{
        
         if(item?.parent?.type==='style'){
          // console.log('item?.parent?.type',item?.parent?.type,item);
            let cssContent = item.data;
            displayContent = scopeCssWithClass('scm',this.prefix, cssContent, this.props.isPreview);
            //  console.log('item?.parent?.type',displayContent);
          }
      }catch(e){

      }
      //LOAD SVG
      try{
        if(tagName==='svg'){
          const renderitm = buildElementString(item);
          return <span dangerouslySetInnerHTML={{ __html: renderitm }} />
        }
      }catch(e){

      }
      
      
      //LOAD OTHER TAGS
      switch(type){
        case 'tag':
        case 'style':
          return <HyperTextElementBuilder
                    elmtParams={elmtParams}
                    attributes={attributes}
                    tagName={tagName} />
        case 'text':
          const itemData = item.data;
          if(item?.parent?.type==='style'){
            displayContent = isSet(displayContent,itemData);
          }else{
            displayContent = itemData;
          }
          
          if (typeof displayContent === 'string') {
            // console.log('displayContent',displayContent,itemData,attributes,elmtParams);
            displayContent = injectVariableValues(itemData,attributes,elmtParams,displayContent);
          }
          return displayContent;
        case 'script':
          if(children.length===0){
              return React.createElement(tagName, {...attributes});
          }else{
              return React.createElement(tagName, {...attributes}, this.convertAndCreateElement(children,{loopData,dataTable,dynamicVar,childActionButtons}));
          }
        default:
          return <></>
      }
      })
      
    }
    
    //CONVERT HTML Event TO REACT EVENT 
   convertToReactEvent = (attributes,fromJs = false)=> {
    const eventHandlerMapping = {
      onclick: 'onClick',
      onmouseover: 'onMouseOver',
      onmouseout: 'onMouseOut',
      onmousedown: 'onMouseDown',
      onmouseup: 'onMouseUp',
      onmousemove: 'onMouseMove',
      onkeydown: 'onKeyDown',
      onkeypress: 'onKeyPress',
      onkeyup: 'onKeyUp',
      onfocus: 'onFocus',
      onblur: 'onBlur',
      onchange: 'onChange',
      onsubmit: 'onSubmit',
      onreset: 'onReset',
      oninput: 'onInput',
      oncontextmenu: 'onContextMenu',
      onwheel: 'onWheel',
      // Add other event handlers as needed 
    };
  
    const reactAttributes = {};
    let jqueryHandlers = []; 
    for (let [key, value] of Object.entries(attributes)) {
      // console.log('eventHandlerMapping',eventHandlerMapping,key);
      if (eventHandlerMapping[key]) {
        const [functionName, args] = splitFunctionAndArgs(value);
        // console.log('functionName',value,functionName,args);
        if (functionName && this.functionMap[functionName]) {
          //  console.log('functionName -1',value,functionName,args);
          if (args) {
            if (value.includes('this')) {
              reactAttributes[eventHandlerMapping[key]] = (e) => this.functionMap[functionName](e);
            } else {
             
              const splitArgs = args.includes(',') ? args.split(',') : [args];
              const cleanedArgs = splitArgs.map(arg => arg.replace(/'/g, ''));
              reactAttributes[eventHandlerMapping[key]] = () => this.functionMap[functionName](...cleanedArgs);
              // console.log('args',cleanedArgs);
            }

           
          } else {
            reactAttributes[eventHandlerMapping[key]] = this.functionMap[functionName];
          }
        } else {
          // console.warn(`reactAttributes - Function '${functionName}' not found in this.functionMap.`);
          // console.warn(`Function '${functionName}' not found in this.functionMap.`);

           // Add className with function name
          reactAttributes["data-action"] = functionName;
           //  Prefer ID if available, else fallback to class
            let selector = "";
            if (attributes.id) {
              selector = `$("#${attributes.id}")`;
            } else {
              selector = `$('[data-action="${functionName}"]')`;
            }

            // if (args) {
            //   jqueryHandlers.push(
            //     `${selector}.off("${key.replace("on", "").toLowerCase()}").on("${key.replace("on", "").toLowerCase()}", function() { ${functionName}(${args}); });`
            //   );
            // } else {
            //   jqueryHandlers.push(
            //     `${selector}.off("${key.replace("on", "").toLowerCase()}").on("${key.replace("on", "").toLowerCase()}", ${functionName});`
            //   );
            // }
            if (args) {
              jqueryHandlers.push(
                `${selector}.off("${key.replace("on", "").toLowerCase()}").on("${key.replace("on", "").toLowerCase()}", function() { 
                  if (typeof ${functionName} === "function") { 
                    ${functionName}(${args}); 
                  } 
                });`
              );
            } else {
              jqueryHandlers.push(
                `${selector}.off("${key.replace("on", "").toLowerCase()}").on("${key.replace("on", "").toLowerCase()}", function() { 
                  if (typeof ${functionName} === "function") { 
                    ${functionName}(); 
                  } 
                });`
              );
            }
            // Build jQuery equivalent string
            // jqueryHandlers.push(
            //     `${selector}.off("${key.replace("on", "").toLowerCase()}").on("${key.replace("on", "").toLowerCase()}", ${functionName});`
            //   // `${selector}.on("${key.replace("on", "").toLowerCase()}", ${functionName});`
            // );
        }
      } else {
        reactAttributes[key] = value;
      }
    }
    if (reactAttributes && reactAttributes.class) {
      
         // 👈 your prefix here
         const scmPrefix = `${this.prefix}-`; 
        // console.log('isClassDefined',isClassDefined(reactAttributes.class))
        reactAttributes.class = reactAttributes.class
        .split(/\s+/) // split by spaces
        .map(cls => {
          // already prefixed → keep as-is
          if (cls.startsWith(scmPrefix)) return cls;
          // console.log('isClassDefined(cls)',cls,isClassDefined(cls,this.state.inlineStyles));

          // if exists in stylesheet → add prefix
          if (isClassDefined(cls,this.state.inlineStyles,scmPrefix)===true) return scmPrefix + cls;

          // otherwise → leave it
          return cls;
        })
        .join(" ");
    }
     
    // console.log('jqueryHandlers',jqueryHandlers);
    if(jqueryHandlers.length>0 && fromJs===true){
      JAVASCRIPT_SCRIPT = [...JAVASCRIPT_SCRIPT,...jqueryHandlers];
        // "$(document).ready(function() {\n  " +
        // jqueryHandlers.join("\n  ") +
        // "\n});";

        
          // JAVASCRIPT_SCRIPT = '';
            // this.setState({htmlElement:updatedHtmlElement});
          // console.log('thishtml',updatedHtmlElement);
      }
     
      // console.log('JAVASCRIPT_SCRIPT jqueryHandlers',JAVASCRIPT_SCRIPT);
    return reactAttributes;
  }
  // getAndLoadAllHandler = (htmlElement)=>{
  //    htmlElement.forEach((item)=>{
  //           const {children} = item;
  //           const attribs = (item.hasOwnProperty('attribs')===true)?item.attribs:{};
  //           this.convertToReactEvent(attribs,true);
  //           if(isSet(children,[]).length>0){
  //               this.getAndLoadAllHandler(item.children);
  //           }
        
  //   });
  //   const JAVASCRIPT_SCRIPTORG = JAVASCRIPT_SCRIPT;
  //   return "$(document).ready(function() {\n  " +
  //       JAVASCRIPT_SCRIPTORG.join("\n  ") +
  //       "\n});";
  // }
  getAndLoadAllHandler = (htmlElement) => {
      // const handlers = [];

      const traverse = (nodes) => {
        if (!nodes || nodes.length === 0) return;

        for (let i = 0; i < nodes.length; i++) {
          const item = nodes[i];
          const { children, attribs = {} } = item;

          // collect handlers efficiently
          this.convertToReactEvent(attribs, true);

          if (children && children.length > 0) {
            traverse(children);
          }
        }
      };

      traverse(htmlElement);
      if(JAVASCRIPT_SCRIPT.length>0){
          return `$(document).ready(function() {
          ${JAVASCRIPT_SCRIPT.join("\n  ")}
        });`;
      }else{
        return '';
      }
      // avoid reassigning global each time
    
};
  
  //GET AND RENDER JAVASCRIPT
  getJsScriptContent =(itemData)=>{
    let  displayContent = itemData;
    const parser = new DOMParser()
    const returnjs = this.getAndLoadAllHandler(this.state.htmlElement);
    JAVASCRIPT_SCRIPT = [];
    const javaScriptsData = displayContent+''+returnjs;
    
    const convertedJS = prefixClassesForJS(this.state.inlineStyles,javaScriptsData,this.prefix);
    // console.log('convertedJS',convertedJS);
    try{
      const doc = parser.parseFromString(convertedJS, 'text/html');
      displayContent = eval(isSet(doc.documentElement.textContent,''));
      return displayContent;
    }catch(e){
      return '';
    }
    
  }

  //ASSIGN/REPLACE VARIABLE TO VALUES 
  injectVariableValues = (itemData,attributes,elmtParams,displayContent)=>{
    const startingIndex = itemData.indexOf('${');
    const endingIndex = itemData.indexOf('}');
    if (itemData.indexOf('${') !== -1 && itemData.indexOf('}') !== -1){
      // console.log('itemData',itemData,attributes,elmtParams);
      let variableValue = itemData.substring((startingIndex), endingIndex);
      variableValue = variableValue.replace(/{/gi,'');
      variableValue = variableValue.replace('$','');
      variableValue = variableValue.replace(/}/gi,'');
      const replacingValue = getOutputFieldsElement({...attributes,value:variableValue.trim()},elmtParams);
      displayContent = itemData.replace('${'+variableValue+'}',replacingValue);
    }
    return displayContent;
  }
  


   
    getStyleContents = (children)=> {
        let styles = [];
        // if (!children || children.length === 0) return styles;
        // console.log('children',children);
        children.forEach((child) => {
            // If this child is a style tag, grab its content
            if (child.name === 'style' && child.children && child.children[0]) {
                styles.push(child.children[0].data);
            }

            // Recurse into this child's children if they exist
            if (child.children && child.children.length > 0) {
                styles = styles.concat(this.getStyleContents(child.children));
            }
        });

        return styles;
    }
    //CONVERT HTML TEMPLATE TO JSON AND SET AS STATE
    convertMarkupToJSON =(wthis)=>{ 
      // console.log('this.props.htmlContent',this.props.htmlContent);
        let dynamicContent = `<Root><scm:body class="scm-page-preview"  id="scm">${this.props.htmlContent}</scm:body></Root>`;
        var promise = htmlToJson.parse(dynamicContent, {
            'HTML': function ($doc) {
            return $doc;
            }
        },function (err, result) {
                // result.HTML[0].children.map((item)=>{
                //     console.log(item.children);
                //     let htmlElement = item.children;
                //     htmlElement.push({...htmlElement});
                // });
        });
        promise.done(function (result) {
            result.HTML[0].children.map((item)=>{
                // console.log(item.children);
                const styleStrings = wthis.getStyleContents(item.children);
                // console.log('styleStrings',styleStrings);
                wthis.setState({htmlElement:item.children,inlineStyles:styleStrings.join('')});
            })
        });
    }

  dynamicSystemHandler = ({selected_rate,btnOption})=>{
  }
 

}

MarkupConversion.defaultProps = {
  layoutObject:{},
  subform_data:[],
  nonFieldGroups:[],
  fieldGroups:[],
  formFields:[],
  validationForms:[],
  onChangeInputAction:()=>{},
  onBlurHandlerAction:()=>{},
  renderProps:[],
  actionButtons:[],
  modType:'',
  DVauditLog:{},
  htmlContent:'',
  layoutForms:true,
  formsPayload:{},
  isPreview:false,
  onChangeResourcesFieldHandler:()=>{},
  onSubmitAutomationHandler:()=>{},
  resourcesList:[],
  outputResponse:{},
  fieldFormPayload:{}
}


const mapDispatchToProps = dispatch => {
    return {
        // Loader: (bool) => dispatch(actions.loader(bool)),
        // succMessage: (msg) => dispatch(actions.succMessage(msg)),
        // failMessage: (msg) => dispatch(actions.failMessage(msg)),
        // warningMessage: (msg) => dispatch(actions.warningMessage(msg)),
        // setFromMappingPayloadAction:(payload)=>dispatch(setFromMappingPayloadAction(payload)),
        // setToPagesAction:(payload)=>dispatch(setToPagesAction(payload)),
        // clearPagesConfiguration:()=>dispatch(clearPagesConfiguration())
        setActiveConfigPagesAction:(type,key)=>dispatch(setActiveConfigPagesAction(type,key)),
        goToHistoryPageAction:()=>dispatch(goToHistoryPageAction()),
        loadPagesConfigAction:(...args)=>dispatch(loadPagesConfigAction(...args))
    };
}
const mapStateToProps = (state) => { 
  return {
    //   fromMappingFields:state.PagesReducer.pagesConfiguration.from_page_mapping,
      // activePage:state.PagesReducer.activePage,
      pageFlows:state.PagesReducer.pageFlows,
  };
}
export default
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(withRouter(MarkupConversion));
